// 録音長制約の front 側対応値。決定源 (SSOT) は yakureki-back
// `yakureki/services/audio_policy.py` (RECORDING_MIN_S / RECORDING_MAX_S)。
// back を変えたらここも揃えること。全レイヤの棚卸は hub log/47 work-log/04。

// 文字起こしが成立する下限 (秒)。境界は back と同じ「10 秒ちょうども NG」(<=)。
// upload 経路 (fallback commit) では back がこの値未満を 400 拒否する。
export const RECORDING_MIN_S = 10
